import { createSlice } from '@reduxjs/toolkit';

export const eventRegisteredSlice = createSlice({
    name: 'eventRegistered',
    initialState: {
        dataToAction: {principalAssistant: '', companions: '', comments: '', assistance: ''}
    },
    reducers: {
        selectEventRegistered: (state, {payload}) => {
            state.dataToAction = payload;
        },
        unSelectEventRegistered: (state) => {
            state.dataToAction = {principalAssistant: '', companions: '', comments: '', assistance: ''}
        }
    }
});

export const { selectEventRegistered, unSelectEventRegistered } = eventRegisteredSlice.actions;